var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppCapture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#000B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4522 15.1552L27.3413 21.3715C25.7871 20.3724 24.0112 19.8915 21.6431 19.8915C17.2764 19.8915 14.8345 22.8146 14.8345 26.6259C14.8345 31.2882 17.6465 33.7675 21.8276 33.7675C23.8628 33.7675 25.6763 33.5084 27.563 32.4723L27.6001 38.5407C26.1939 39.2438 24.1587 39.6879 21.0137 39.7247C11.5781 39.7618 7.43408 33.5824 7.43408 26.7369C7.43408 20.4835 12.0591 14.0451 21.1245 13.9711C23.8257 13.934 26.1201 14.3409 27.4522 15.1552Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5659 37.9118C44.1607 39.0219 41.4224 39.6139 37.981 39.6139C33.208 39.6139 29.4707 37.6156 29.4707 33.1754C29.4707 28.6981 33.3189 27.07 37.7593 27.07C38.7954 27.07 39.6465 27.1439 40.3491 27.255V27.0328C40.3491 25.7379 39.313 24.8129 36.7231 24.8129C34.9839 24.8129 33.0229 25.2567 31.1729 25.997L31.1357 20.8165C33.0601 20.0765 35.2432 19.5953 37.7593 19.5953C43.3833 19.5953 46.5659 22.1486 46.5659 27.8099V37.9118ZM40.3491 31.4733C39.9053 31.3253 39.313 31.2142 38.4624 31.2142C36.7974 31.2142 35.6128 31.6952 35.6128 33.0275C35.6128 34.3595 36.7603 34.9884 38.3882 34.9884C39.2026 34.9884 39.8315 34.8776 40.3491 34.6554V31.4733Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppCapture);
export default __webpack_public_path__ + "static/media/B_app_Capture.eb6fb291adf12262083fcf7dfd019fd4.svg";
export { ForwardRef as ReactComponent };